import { ChipLink } from './chip-link';

export default ChipLink;
